import resume from '../assets/pdf/resume.pdf'
import profileImg from '../assets/png/Img.jpeg';


export const headerData = {
    name: 'Satheesh R',
    title: "Software Developer",
    desciption:"I write bugs. I fix them. I write better bugs.",
    image: profileImg,
    resumePdf: resume
}
